import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";
import { Save, Plus, Trash2 } from "lucide-react";

const DEFAULTS = {
  labels: { menu: "Menu", offices: "Unidades", ecosystem: "Ecossistema", social: "Social", legal: "Política de Privacidade", rights: "Todos os direitos reservados." },
  copyright_extra: "", tagline_override: "",
};

let _fuid = 0;
const withKeyE = (o) => ({ ...o, _k: o._k ?? `e${++_fuid}` });
const stripKeysE = (arr) => arr.map(({ _k, ...rest }) => rest);

export default function FooterEditor() {
  const [conf, setConf] = useState(DEFAULTS);
  const [ecosystem, setEcosystem] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content/kv/footer_config").then(({data}) => data && setConf({...DEFAULTS, ...data, labels: {...DEFAULTS.labels, ...(data.labels || {})}}));
    api.get("/content/kv/ecosystem").then(({data}) => Array.isArray(data) && setEcosystem(data.map(withKeyE)));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/content/kv/footer_config", { value: conf });
      await api.put("/content/kv/ecosystem", { value: stripKeysE(ecosystem) });
      toast.success("Rodapé atualizado.");
    } catch { toast.error("Erro ao salvar."); }
    finally { setSaving(false); }
  };

  const updL = (k, v) => setConf(c => ({...c, labels: {...c.labels, [k]: v}}));
  const updE = (i, k, v) => setEcosystem(arr => { const a = [...arr]; a[i] = {...a[i], [k]: v}; return a; });
  const addE = () => setEcosystem(arr => [...arr, withKeyE({ name: "", url: "" })]);
  const removeE = (i) => setEcosystem(arr => arr.filter((_, j) => j !== i));

  return (
    <div>
      <div className="flex justify-between items-end mb-6">
        <div><h1 className="font-display text-4xl">Rodapé</h1><p className="text-sm text-neutral-500 mt-1">Labels das seções, selos do ecossistema, copyright.</p></div>
        <button onClick={save} disabled={saving} data-testid="footer-save" className="bg-black text-white text-sm px-5 py-2.5 rounded-full hover:bg-accent-orange disabled:opacity-50"><Save className="w-3 h-3 inline mr-1" /> Salvar</button>
      </div>

      <section className="mb-8 border border-black/10 p-5 rounded">
        <div className="font-semibold text-sm uppercase tracking-widest text-neutral-700 mb-3">Labels das seções</div>
        <div className="grid md:grid-cols-3 gap-3">
          {Object.entries(conf.labels).map(([k, v]) => (
            <div key={k}><label className="text-xs text-neutral-500 capitalize">{k}</label><input value={v} onChange={(e) => updL(k, e.target.value)} className="w-full border border-black/15 px-3 py-2 rounded text-sm" data-testid={`footer-label-${k}`} /></div>
          ))}
        </div>
      </section>

      <section className="mb-8 border border-black/10 p-5 rounded">
        <div className="font-semibold text-sm uppercase tracking-widest text-neutral-700 mb-3">Outros</div>
        <div className="grid md:grid-cols-2 gap-3">
          <div><label className="text-xs text-neutral-500">CNPJ / texto extra do rodapé</label><input value={conf.copyright_extra} onChange={(e) => setConf({...conf, copyright_extra: e.target.value})} className="w-full border border-black/15 px-3 py-2 rounded text-sm" /></div>
          <div><label className="text-xs text-neutral-500">Override da tagline (deixe vazio para usar a global)</label><input value={conf.tagline_override} onChange={(e) => setConf({...conf, tagline_override: e.target.value})} className="w-full border border-black/15 px-3 py-2 rounded text-sm" /></div>
        </div>
      </section>

      <section className="border border-black/10 p-5 rounded">
        <div className="flex justify-between items-center mb-3"><div className="font-semibold text-sm uppercase tracking-widest text-neutral-700">Ecossistema / Selos</div><button onClick={addE} className="text-xs bg-accent-yellow px-3 py-1 rounded-full font-semibold" data-testid="add-ecosystem"><Plus className="w-3 h-3 inline" /> Adicionar</button></div>
        <div className="space-y-2">
          {ecosystem.map((b, i) => (
            <div key={b._k || `eco-${i}`} className="grid grid-cols-12 gap-2 items-center" data-testid={`ecosystem-${i}`}>
              <input value={b.name} onChange={(e) => updE(i, "name", e.target.value)} placeholder="Google Partner" className="col-span-4 border border-black/15 px-2 py-1.5 rounded text-sm" />
              <input value={b.url} onChange={(e) => updE(i, "url", e.target.value)} placeholder="URL (opcional)" className="col-span-7 border border-black/15 px-2 py-1.5 rounded text-sm" />
              <button onClick={() => removeE(i)} className="text-red-500 text-xs"><Trash2 className="w-3 h-3 inline" /></button>
            </div>
          ))}
          {!ecosystem.length && <div className="text-xs text-neutral-500 text-center py-4">Nenhum selo ainda.</div>}
        </div>
      </section>
    </div>
  );
}
